import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputSwitchModule } from 'primeng/inputswitch';
import { SharedModule } from '../shared/shared.module';
import { AppNavbarComponent } from './app-navbar/app-navbar.component';
import { CommentsViewComponent } from './comments-view/comments-view.component';
import { DiffViewComponent } from './diff-view/diff-view.component';
import { EditToolbarComponent } from './edit-toolbar/edit-toolbar.component';
import { ExportFilterComponent } from './export-filter/export-filter.component';
import { FooterComponent } from './footer/footer.component';
import { HistoryViewComponent } from './history-view/history-view.component';
import { ManuComponent } from './inputs/manu/manu.component';
import { RequiredDirective } from './inputs/required.directive';
import { SettingDropdownComponent } from './inputs/setting-dropdown/setting-dropdown.component';
import { NewCourseComponent } from './new-course/new-course.component';
import { PasswordChangeComponent } from './password-change/password-change.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    InputSwitchModule,
    SharedModule,
    ModalModule,
    BsDatepickerModule,
    FontAwesomeModule,
    CollapseModule.forRoot(),
    AutoCompleteModule,
  ],
  declarations: [AppNavbarComponent, FooterComponent, ManuComponent, EditToolbarComponent,
    PasswordChangeComponent, RequiredDirective, ExportFilterComponent, CommentsViewComponent,
    HistoryViewComponent, DiffViewComponent, NewCourseComponent, SettingDropdownComponent,
  ],
  exports: [AppNavbarComponent, FooterComponent, ManuComponent, EditToolbarComponent,
    PasswordChangeComponent, RequiredDirective, CommentsViewComponent,
    HistoryViewComponent, DiffViewComponent, NewCourseComponent, SettingDropdownComponent, InputSwitchModule
  ]
})
export class UiModule { }
